import { CaregiverResidentEmarPageContent } from "../../caregiver/pages/CaregiverResidentEmarPage";

const SharedResidentEmarPage = () => (
  <CaregiverResidentEmarPageContent sharedMode />
);

export default SharedResidentEmarPage;
